<template>
  <div>
        <el-table
        :data="score_detail"
        style="width: 100%">
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="eval_type" label="评估类型" min-width="20%"></el-table-column>
            <el-table-column prop="assessor" label="评估人姓名" min-width="25%"></el-table-column>
            <el-table-column prop="ori_score" label="评估得分" min-width="20%"></el-table-column>
            <el-table-column prop="percent" label="计算占比" min-width="25%"></el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    // data() {
    //     return {
    //         score_detail: [
    //             {
    //                 eval_type: '',
    //                 assessor: '',
    //                 ori_score: 0,
    //                 percent: 0,
    //             }]
    //     }
    // },
    props: ['score_detail'],
};
</script>

<style scoped>
::v-deep .el-form-item {
    margin-bottom: 0;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* .search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
} */
</style>